import qs from "qs";

export const paramsSerializer = (params: Record<string, any>) =>
  qs.stringify(params, { arrayFormat: "repeat" });
